import { useEffect, useState, useRef, useCallback } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";

import { usePageMetadata } from '../../hooks/usePageMetadata';
import styles from "./Home.module.css"
import mylo_logo from "../../assets/images/logo.svg";
import mylo_home_banner from "../../assets/images/mylo_home_banner.svg";
import mylo_home_banner_short from "../../assets/images/mylo_home_banner_short.svg";

import mylo_safe_white_red from "../../assets/images/mylo_safe_white_red.svg";
import mylo_safe_red_white from "../../assets/images/mylo_safe_red_white.svg";
import mylo_tradies_white_orange from "../../assets/images/mylo_tradies_white_orange.svg";
import mylo_tradies_orange_white from "../../assets/images/mylo_tradies_orange_white.svg";
import mylo_home_mods_white_blue from "../../assets/images/mylo_home_mods_white_blue.svg";
import mylo_home_mods_blue_white from "../../assets/images/mylo_home_mods_blue_white.svg";
import mylo_safe_black_white from "../../assets/images/mylo_safe_black_white.svg";
import mylo_tradies_black_white from "../../assets/images/mylo_tradies_black_white.svg";
import mylo_home_mods_black_white from "../../assets/images/mylo_home_mods_black_white.svg";
import team_banner from "../../assets/images/team_banner.jpg";
import technology from "../../assets/images/technology.png";
import smoke_alarm from "../../assets/images/smoke_alarm.jpg";
import cloud1 from "../../assets/images/cloud1.svg";
import cloud2 from "../../assets/images/cloud2.svg";
import cloud3 from "../../assets/images/cloud3.svg";
import car1 from "../../assets/images/car1.svg";
import car2 from "../../assets/images/car2.svg";
import ndis_logo from "../../assets/images/ndis_logo.svg";

import Footer from "../Footer"
import Topbar from "../Topbar"


const Banner = () => {
	const [activeIndex, setActiveIndex] = useState(null);
	const [animating, setAnimating] = useState(false);
	const [isMobile, setIsMobile] = useState(window.innerWidth <= 600);
	const containerRef = useRef(null)
	const banners = {
		"/": {
			expanded_colour: "mylo_home_banner_e",
			shrank_colour: "mylo_home_banner_s",
			shrank_img: mylo_logo,
			expanded_img: mylo_logo,
			expanded_img_black: mylo_logo,
			heading: "Property Solutions, Simplified.",
			subheading: "MYLO is your all-in-one solution for safety compliance, property maintenance and home modifications across Melbourne and NSW. We make it easier for property managers, rental providers, tenants, participants, support coordinators, and OTs to get the support they need. Delivering reliable, cost-effective, and simplified solutions, MYLO has you covered for any service requirements, big or small.",
			icon: 'fa-solid fa-plus'
		},
		"safety": {
			expanded_colour: "mylo_safe_banner_e",
			shrank_colour: "mylo_safe_banner_s",
			shrank_img: mylo_safe_red_white,
			expanded_img: mylo_safe_white_red,
			expanded_img_black: mylo_safe_black_white,
			heading: "Property Safety, Simplified.",
			subheading: "Protect your property & your tenants with MYLO safety compliance. End-to-end safety checks that take the stress out of compliance—trusted by property managers and homeowners to protect what matters most.",
			icon: 'fa-solid fa-house-fire'
		},
		"tradies": {
			expanded_colour: "mylo_tradies_banner_e",
			shrank_colour: "mylo_tradies_banner_s",
			shrank_img: mylo_tradies_orange_white,
			expanded_img: mylo_tradies_white_orange,
			expanded_img_black: mylo_tradies_black_white,
			heading: "Property Maintenance, Simplified.",
			subheading: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam turpis dolor, molestie non purus a, fermentum feugiat elit. Cras vel ornare sapien. Fusce facilisis lectus at tortor tristique consectetur. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Fusce id augue eget leo sagittis tincidunt.",
			icon: 'fa-solid fa-hammer-brush'
		},
		"home-modifications": {
			expanded_colour: "mylo_home_mods_banner_e",
			shrank_colour: "mylo_home_mods_banner_s",
			shrank_img: mylo_home_mods_blue_white,
			expanded_img: mylo_home_mods_white_blue,
			expanded_img_black: mylo_home_mods_black_white,
			heading: "Property Modifications, Simplified.",
			subheading: "Creating Safer Spaces for Everyday Living. Specialists in a wide range of accessibility equipment and mobility access modification services tailored to your home.",
			icon: 'fa-solid fa-universal-access',
			ndis: ndis_logo
		}
	}


	useEffect(() => {
		const handleResize = () => {
			setIsMobile(window.innerWidth <= 600);
		};

		window.addEventListener('resize', handleResize);
		return () => window.removeEventListener('resize', handleResize);
	}, []);


  	const isContainerFullyVisible = () => {
    	const el = containerRef.current;
    	if (!el) return false;
    	const { top, bottom, left, right } = el.getBoundingClientRect();

    	return (
      		top >= 0 &&
      		left >= 0 &&
      		bottom <= window.innerHeight &&
      		right <= window.innerWidth
    	);
  	};

  	const handleHover = (index) => {
	    if (isMobile || index === activeIndex || animating || !isContainerFullyVisible()) return;

	    setAnimating(true);
	    setActiveIndex(null);

		setActiveIndex(index);
		setAnimating(false);
  	};

  	const handleMouseLeave = () => {
    	if (isMobile || animating) return;

    	setActiveIndex(null);
    	setActiveIndex(0);
  	}

	return (
		<div className={styles.banner_container}>
			<div className={styles.banner_heading_container}>
				<div className={styles.banner_headings}>
					<h1 className={`xxxxl3 forma bold ${styles.non_optimised}`}><span>MYLO,</span> taking care of what <br/>matters most to your property.</h1>
					<h1 className={`xxxl3 forma bold ${styles.optimised}`}><span>MYLO,</span> taking care of what<br/>matters most to your property.</h1>
				</div>

				<a className={styles.banner_btn} href={"tel:+136956"}>
					<p className={`m2 inter medium`}>13 MYLO (13 69 56)</p>
					<i className="fa-solid fa-phone m3"></i>
				</a>
			</div>

			<div className={styles.banner_items_container} ref={containerRef}>
		      	<div className={styles.banner_items} onMouseLeave={handleMouseLeave}>
			        {Object.keys(banners).map((bannerKey, index) => {
			        	const banner = banners[bannerKey]
						const isDefault = activeIndex === null && index === 0;
						const isExpanding = activeIndex !== null && activeIndex === index;
						const isShrinking = activeIndex !== null && activeIndex !== index;
						const isInactive = activeIndex === null && index !== 0;

						const alwaysExpanded = isMobile

			          	return (
			            	<button
			              		key={index}
								className={`
									${styles.banner_item}
									${isDefault ? styles[banner.expanded_colour] : isExpanding ? styles[banner.expanded_colour] : styles[banner.shrank_colour]}
									${alwaysExpanded ? styles.expand : isDefault ? styles.default : isExpanding ? styles.expand : isShrinking ? styles.shrink : ''}
								`}
			              		onMouseEnter={() => handleHover(index)}
			              		onClick={() => window.location = bannerKey}
			            	>
			            		{!alwaysExpanded &&
			            			<>
			  							<div
									        className={`
									          	${styles.banner_img_container}
									          	${
									            	isExpanding
									              		? styles.fadeOutFirst
									              		: isShrinking || isInactive
									              		? styles.fadeInThird
									              		: ''
									          	}
									        `}
			  							>
		    								<img src={banner['shrank_img']} />
		  								</div>
  								
										<div
											className={`
												${styles.banner_plus_container}
										        ${
										            isExpanding
										              	? styles.fadeOutFirst
										              	: isShrinking || isInactive
										              	? styles.fadeInSecond
										              	: styles.hidden
										          	}
											`}
										>
											<i className={`${banner.icon}`}></i>
										</div>
									</>
								}

  								<div
							        className={`
							          	${styles.banner_img_container_full}
							          	${
							            	alwaysExpanded || isExpanding || isDefault
							              		? styles.fadeInSecond
							              		: isShrinking
							              		? styles.fadeOutFirst
							              		: styles.hidden
							          	}
							        `}
  								>
									<img src={alwaysExpanded ? banner['expanded_img_black'] : banner['expanded_img']}/>

									<div className={styles.full_heading_flex}>
										<p className={`xl3 forma medium ${styles.optimised} ${(index === 0 || alwaysExpanded) ? styles.banner_subtext_black : styles.banner_subtext}`}>{banner.heading}</p>
										<p className={`xxxxl3 forma medium ${styles.non_optimised} ${(index === 0 || alwaysExpanded) ? styles.banner_subtext_black : styles.banner_subtext}`}>{banner.heading}</p>
										<p className={`m2 inter medium ${styles.non_optimised} ${(index === 0 || alwaysExpanded) ? styles.banner_subtext_black : styles.banner_subtext}`}>{banner.subheading}</p>
									</div>

									{bannerKey === "home-modifications" &&
										<div className={styles.banner_ndis_img}>
											<img src={banner.ndis}/>
										</div>
									}

									<i className={`${styles.optimised} fa-thin fa-arrow-right xxxl3 ${(index === 0 || alwaysExpanded) ? styles.arrow_right_black : styles.arrow_right}`}></i>
									<i className={`${styles.non_optimised} fa-thin fa-arrow-right xxxxxxxl3 ${(index === 0 || alwaysExpanded) ? styles.arrow_right_black : styles.arrow_right}`}></i>
								</div>
			            	</button>
			            )
			        })}
			    </div>


					{/* <div className={`${styles.banner_item} ${styles.mylo_safe_banner}`}> */}
						{/* <div className={styles.banner_img_container_full}> */}
						{/* 	<img src={mylo_logo}/> */}
						{/* 	<p className={`xxxxl3 forma medium ${styles.banner_subtext}`}>MYLO has cost-effective and professional solutions for all your property needs.</p> */}
						{/* 	<i className={`fa-thin fa-arrow-right xxxxxxxl3 ${styles.arrow_right}`}></i> */}
						{/* </div> */}
					{/* </div> */}

					{/* <div className={`${styles.banner_item} ${styles.mylo_tradies_banner}`}> */}
{/* 						<div className={styles.banner_img_container_full}> */}
{/* 							<img src={mylo_logo}/> */}
{/* 							<p className={`xxxxl3 forma medium ${styles.banner_subtext}`}>MYLO has cost-effective and professional solutions for all your property needs.</p> */}
{/* 							<i className={`fa-thin fa-arrow-right xxxxxxxl3 ${styles.arrow_right}`}></i> */}
{/* 						</div> */}
{/*  */}
{/* 						<div className={styles.banner_plus_container}> */}
{/* 							<i className="fa-thin fa-plus"></i> */}
{/* 						</div> */}
					{/* </div> */}

					{/* <div className={`${styles.banner_item} ${styles.mylo_home_mods_banner}`}> */}
						{/* <div className={styles.banner_img_container}> */}
						{/* 	<img src={mylo_home_mods_white_blue}/> */}
						{/* </div> */}

{/* 						<div className={styles.banner_img_container_full}> */}
{/* 							<img src={mylo_logo}/> */}
{/* 							<p className={`xxxxl3 forma medium ${styles.banner_subtext}`}>MYLO has cost-effective and professional solutions for all your property needs.</p> */}
{/* 							<i className={`fa-thin fa-arrow-right xxxxxxxl3 ${styles.arrow_right}`}></i> */}
{/* 						</div> */}
{/*  */}
{/* 						<div className={styles.banner_plus_container}> */}
{/* 							<i className="fa-thin fa-plus"></i> */}
{/* 						</div> */}
					{/* </div> */}
			</div>
		</div>
	)
}

const HouseBanner = () => {
  	const refs = {
    	car1: useRef(null),
    	car2: useRef(null),
    	cloud1: useRef(null),
    	cloud2: useRef(null),
    	cloud3: useRef(null),

    	car1opt: useRef(null),
    	cloud1opt: useRef(null)
  	};

  	const config = [
    	{ key: "car1", speed: 0.4, dir: 1 },
    	{ key: "car2", speed: 0.4, dir: -1 },
    	{ key: "cloud1", speed: 0.2, dir: 1 },
    	{ key: "cloud2", speed: 0.2, dir: -1 },
    	{ key: "cloud3", speed: 0.2, dir: -1 },

    	{ key: "car1opt", speed: 0.2, dir: 1 },
    	{ key: "cloud1opt", speed: 0.2, dir: -1 }
  	];

  	const targetXs = useRef(config.map(() => 0));
  	const currentXs = useRef(config.map(() => 0));

  	useEffect(() => {
    	const handleScroll = () => {
      		const y = window.scrollY;
      		config.forEach((c, i) => {
        		targetXs.current[i] = y * c.speed;
      		});
    	};

    	window.addEventListener("scroll", handleScroll, { passive: true });

    	let rafId;
    	const animate = () => {
      		config.forEach((c, i) => {
        		const el = refs[c.key].current;
        		if (!el) return;
        		currentXs.current[i] += (targetXs.current[i] - currentXs.current[i]) * 0.1;
        		el.style.transform = `translateX(${currentXs.current[i] * c.dir}px)`;
      		});

      		rafId = requestAnimationFrame(animate);
    	};

    	rafId = requestAnimationFrame(animate);

    	return () => {
      		window.removeEventListener("scroll", handleScroll);
      		cancelAnimationFrame(rafId);
    	};
  	}, []);


	return (
		<div className={styles.house_banner_container}>
			<img src={mylo_home_banner} className={`${styles.car_banner} ${styles.non_optimised}`}/>
			<img src={car1} className={`${styles.car1} ${styles.non_optimised}`} ref={refs.car1}/>
			<img src={car2} className={`${styles.car2} ${styles.non_optimised}`} ref={refs.car2}/>
			<img src={cloud1} className={`${styles.cloud1} ${styles.non_optimised}`} ref={refs.cloud1}/>
			<img src={cloud2} className={`${styles.cloud2} ${styles.non_optimised}`} ref={refs.cloud2}/>
			<img src={cloud3} className={`${styles.cloud3} ${styles.non_optimised}`} ref={refs.cloud3}/>

			<img src={mylo_home_banner_short} className={`${styles.car_banner} ${styles.optimised}`}/>
			<img src={car1} className={`${styles.car1opt} ${styles.optimised}`} ref={refs.car1opt}/>
			<img src={cloud1} className={`${styles.cloud1opt} ${styles.optimised}`} ref={refs.cloud1opt}/>
		</div>
	)
}

const CompanyMessage = () => {
	return (
		<div className={styles.cmessage_container}>
			<div className={styles.transition_container} style={{ top: '-80px' }}>
				<div className={styles.transition_effect_1} style={{ top: '50px', borderTopLeftRadius: '30px', borderTopRightRadius: '30px', background: "#fdde42" }}/>
				<div className={styles.transition_effect_2} style={{ top: '20px', borderTopLeftRadius: '30px', borderTopRightRadius: '30px', background: "#fdde42" }}/>
				<div className={styles.transition_effect_3} style={{ top: '-10px', borderTopLeftRadius: '30px', borderTopRightRadius: '30px', background: "#fdde42" }}/>
			</div>

			<div className={styles.cmessage_content_container}>
				<img src={mylo_logo}/>
				<div className={styles.cmessage_content}>
					<p className={`xxxxl3 forma bold ${styles.cmessage_banner}`}>Helping you care for properties and the people who live in them.</p>
					<p className={`m2 inter light`}>Through our Safe, Tradies and Home Modifications divisions, at MYLO, we make it simple to stay on top of everything your property needs. Whether you're managing rentals, maintaining your own home, or supporting someone through the NDIS, we deliver expert services across safety compliance, general maintenance, and custom home modifications. Our qualified team works with care, precision, and a deep understanding of regulations—providing a streamlined way to meet your obligations and protect the people who rely on you.<br/><br/>What sets us apart is our care, reliability, and attention to detail. Every service is handled by experienced professionals who take pride in doing things right the first time. Whether it’s ensuring compliance, upgrading accessibility or keeping your property running smoothly, MYLO is here to support you with clear, end-to-end solutions you can trust.</p>

					<button className={styles.cmessage_cta_button} onClick={() => window.location = `/contact`}>
						<p className={`m2 inter medium`}>Enquire Now!</p>
						<i className="fa-solid fa-circle-info m3"></i>
					</button>
				</div>
			</div>

			<div className={styles.transition_container} style={{ bottom: '-80px' }}>
				<div className={styles.transition_effect_1} style={{ bottom: '50px', borderBottomLeftRadius: '30px', borderBottomRightRadius: '30px', background: "#fdde42" }}/>
				<div className={styles.transition_effect_2} style={{ bottom: '20px', borderBottomLeftRadius: '30px', borderBottomRightRadius: '30px', background: "#fdde42" }}/>
				<div className={styles.transition_effect_3} style={{ bottom: '-10px', borderBottomLeftRadius: '30px', borderBottomRightRadius: '30px', background: "#fdde42" }}/>
			</div>
		</div>
	)
}

const BannerImage = () => {
	return (
		<div className={styles.bannerimg_wrapper}>
			<div className={styles.bannerimg_container}/>
			<p className={`xxxxxl3 forma bold ${styles.bannerimg_banner}`}>Property services that make<br/>everyday life that little bit easier</p>
		</div>
	)
}


const Services = () => {
	const [service, setService] = useState("Safety")
	const [solutionSelected, setSolutionSelected] = useState("Smoke Alarms")
	const data = {
		"Safety": {
			colour: "#cf2930",
			subcolour: "#cf293099",
			heading: "Protect your property, protect your tenants. Don’t risk it",
			subtext: "From smoke alarms to gas and electrical safety, MYLO covers every aspect of rental safety compliance with precision and care. Our fully qualified technicians carry out thorough inspections, identify issues early, and ensure properties meet all legal obligations under Victorian legislation. We provide clear, concise reports and practical next steps, so property managers and landlords can stay informed and confident in their compliance. With a strong focus on reliability, professionalism, and accountability, MYLO is a trusted partner for agents and owners who want safety done right—no shortcuts, no confusion, just complete peace of mind.",
			solutions: ["Smoke Alarms", "Rental Minimum Standards Checks", "Smoke Alarm Testing and Servicing", "Free Battery Replacements", "Switchboard Testing", "Appliance Testing", "Earth Continuity", "Power Points", "Gas Leaks", "Carbon Monoxide", "Negative Pressure", "LPG Tank Checks"],
		},
		"Tradies": {
			colour: "#f56329",
			subcolour: "#f5632999",
			heading: "Look after your property, and it will look after you",
			subtext: "MYLO Tradies services are designed to take the hassle out of everyday property maintenance. Whether it’s a quick fix, ongoing upkeep, or a bigger repair job, our trusted team of skilled tradespeople delivers reliable, high-quality work with minimal disruption. We understand the pressures property managers and owners face, which is why we focus on clear communication and prompt scheduling, leading to consistent results and lower fees. With a single point of contact and a dependable crew on hand, MYLO makes it easy to keep properties well-maintained, compliant, and tenant-ready—saving time, reducing stress, and ensuring nothing gets overlooked.",
			solutions: ["Plumbing", "Electrical", "Gardening", "Handyman", "Roof Cleaning", "Gutter Cleaning", "Locksmith", "Fence Painting", "Garage Doors", "And More!"],
		},
		"Home Modifications": {
			colour: "#1c75ba",
			subcolour: "#1c75ba99",
			heading: "Modification Services for Disability and Aged Care",
			subtext: "At MYLO, we specialise in delivering high-quality home modification services that enhance accessibility, safety, and independence for people with disability and the elderly. As a registered NDIS provider, we take a personalised and compassionate approach to every project, ensuring each solution is tailored to suit individual needs and support long-term, independent living. With extensive experience in property adaptations, we’re committed to creating safe, comfortable, and functional spaces that empower our clients to live confidently at home. With a commitment to quality and care, trust MYLO for expert guidance and reliable modifications that make a meaningful difference in everyday living.",
			solutions: ["General Home Safety Modifications", "Access & Mobility Solutions", "Bathroom Modifications", "Kitchen Modifications", "Grab Rails & Support Poles", "Custom Ramps & Platforms", "External Access Enhancements", "Floor Safety Solutions", "Property Landscaping & Maintenance", "General Repairs & Maintenance"]
		}
	}


	const toggleService = (serv) => {
		setSolutionSelected(data[serv]['solutions'][0])
		setService(serv)
	}

	const handleNavigate = (loc) => {
		switch (service) {
			case 'Safety':
				window.location = `/safety`
				break
			case 'Tradies':
				// window.location = `/tradies`
				break
			case 'Home Modifications':
				window.location = `/home-modifications`
				break
		}
	}

	return (
		<div className={styles.services_container}>
			<div className={styles.transition_container} style={{ top: '-80px' }}>
				<div className={styles.transition_effect_1} style={{ top: '50px', borderTopLeftRadius: '30px', borderTopRightRadius: '30px', background: "#cacaca" }}/>
				<div className={styles.transition_effect_2} style={{ top: '20px', borderTopLeftRadius: '30px', borderTopRightRadius: '30px', background: "#cacaca" }}/>
				<div className={styles.transition_effect_3} style={{ top: '-10px', borderTopLeftRadius: '30px', borderTopRightRadius: '30px', background: "#cacaca" }}/>
			</div>

			<div className={styles.inner_services}>
				<div className={styles.services_catheaders}>
					<p className={`xxxxl3 forma bold`}>MYLO <span className={service === "Safety" ? styles.ms_c : service === "Tradies" ? styles.mt_c : styles.mh_c}>{service}</span></p>
					<i className={`fa-thin fa-arrow-right xxxl3 ${styles.non_optimised}`}></i>
				</div>

				<p className={`xl1 forma medium ${styles.services_catsubheader}`}>With three clear service channels, MYLO provides<br/>support & maintenance for all your property needs.</p>

				<div className={styles.service_buttons}>
					<button className={`${styles.service_control_btn} ${service === "Safety" ? styles.white_c : styles.ms_c} ${service === "Safety" && styles.service_control_btn_active} ${service === "Safety" && styles.ms_bg}`} onClick={() => toggleService("Safety")}>
						<p className={`m3 inter medium`}>MYLO Safety</p>
						<i className="fa-solid fa-circle-info l2"></i>
					</button>

					<button className={`${styles.service_control_btn} ${service === "Tradies" ? styles.white_c : styles.mt_c} ${service === "Tradies" && styles.service_control_btn_active} ${service === "Tradies" && styles.mt_bg}`} onClick={() => toggleService("Tradies")}>
						<p className={`m3 inter medium`}>MYLO Tradies</p>
						<i className="fa-solid fa-circle-info l2"></i>
					</button>

					<button className={`${styles.service_control_btn} ${service === "Home Modifications" ? styles.white_c : styles.mh_c} ${service === "Home Modifications" && styles.service_control_btn_active} ${service === "Home Modifications" && styles.mh_bg}`} onClick={() => toggleService("Home Modifications")}>
						<p className={`m3 inter medium`}>MYLO Home Modifications</p>
						<i className="fa-solid fa-circle-info l2"></i>
					</button>
				</div>

				<div className={`${styles.service_inner} ${service === "Safety" ? styles.ms_bg : service === "Tradies" ? styles.mt_bg : styles.mh_bg}`}>
					<div className={styles.transition_container} style={{ top: '-80px', backgroundColor: "#cacaca" }}>
						<div className={styles.transition_effect_1} style={{ top: '50px', background: data[service]['colour'] }}/>
						<div className={styles.transition_effect_2} style={{ top: '20px', background: data[service]['colour'] }}/>
						<div className={styles.transition_effect_3} style={{ top: '-10px', background: data[service]['colour'] }}/>
					</div>	

					<div className={styles.service_inner_container}>
						<div className={styles.service_inner_heading}>
							<p className={`xl3 forma medium`}>MYLO {service}</p>
							<i className="fa-thin fa-arrow-right xl1"></i>
							<p className={`xl3 forma medium ${styles.non_optimised}`} style={{ opacity: .5 }}>{data[service]['heading']}</p>
						</div>

						<p className={`xl3 forma medium ${styles.optimised} ${styles.service_inner_subheading_opt}`} style={{ opacity: .5 }}>{data[service]['heading']}</p>
						<p className={`m2 inter light`}>{data[service]['subtext']}</p>

						<div className={styles.services_overview_split}>
							<div className={styles.services_overview_item}>
								{data[service]['solutions'].map((sol) => (
									<button onClick={() => setSolutionSelected(sol)}><p className={`xl2 inter bold`} style={solutionSelected === sol ? { color: data[service]['colour'] }: { color: data[service]['subcolour'] }}>{sol}</p></button>
								))}
							</div>
							
							<div className={styles.services_overview_img}>
								<img src={smoke_alarm}/>
							</div>
						</div>
					</div>

					<div className={styles.service_bottom_btns}>
						<div className={styles.service_bottom_btns_circle}><i className="fa-thin fa-arrow-right xl3"></i></div>
						<p className={`m2 inter light`}>MYLO's quality of service is everything you'll need this year to find<br/>that peace of mind knowing all your safety needs are taken care of.</p>

						<button className={`${styles.service_bottom_btns_btn} ${styles.non_optimised}`} onClick={() => handleNavigate()}>
							<p className={`m2 inter medium`}>Discover More</p>
							<i className="fa-solid fa-circle-info m3"></i>
						</button>
					</div>

					<button className={`${styles.service_bottom_btns_btn} ${styles.optimised}`} onClick={() => handleNavigate()}>
						<p className={`m2 inter medium`}>Discover More</p>
						<i className="fa-solid fa-circle-info m3"></i>
					</button>
				</div>
			</div>

			<div className={styles.transition_container} style={{ bottom: '-80px' }}>
				<div className={styles.transition_effect_1} style={{ bottom: '50px', borderBottomLeftRadius: '30px', borderBottomRightRadius: '30px', background: data[service]['colour'] }}/>
				<div className={styles.transition_effect_2} style={{ bottom: '20px', borderBottomLeftRadius: '30px', borderBottomRightRadius: '30px', background: data[service]['colour'] }}/>
				<div className={styles.transition_effect_3} style={{ bottom: '-10px', borderBottomLeftRadius: '30px', borderBottomRightRadius: '30px', background: data[service]['colour'] }}/>
			</div>
		</div>
	)
}

const BannerImageTwo = () => {
	return (
		<div className={styles.bannerimg_wrapper}>
			<div className={styles.bannerimg2_container}/>
			<p className={`xxxxxl3 forma bold ${styles.bannerimg_bannertwo}`}>Affordable, practical and reliable<br/>property solutions to give you peace of mind.</p>
		</div>
	)
}

const Technology = () => {
	return (
		<div className={styles.tech_container}>
			<div className={styles.transition_container} style={{ top: '-80px' }}>
				<div className={styles.transition_effect_1} style={{ top: '50px', borderTopLeftRadius: '30px', borderTopRightRadius: '30px', background: "#282828" }}/>
				<div className={styles.transition_effect_2} style={{ top: '20px', borderTopLeftRadius: '30px', borderTopRightRadius: '30px', background: "#282828" }}/>
				<div className={styles.transition_effect_3} style={{ top: '-10px', borderTopLeftRadius: '30px', borderTopRightRadius: '30px', background: "#282828" }}/>
			</div>

			<div className={styles.tech_inner_container}>
				<div className={styles.tech_heading}>
					<i className={`fa-solid fa-microchip xxxxxl3 ${styles.optimised}`}></i>
					<p className={`xxxxl3 forma bold`}>Technology</p>
					<i className={`fa-solid fa-microchip xxxxxl3 ${styles.non_optimised}`}></i>
				</div>

				<p className={`xxl3 forma medium ${styles.tech_subheading_main}`}>Efficient, integrated and seamless technology that simply keeps you in control of your property.</p>
				<p className={`m2 inter light ${styles.tech_subheading}`}>At the heart of our service is smart, intuitive technology designed to make property management simple. Our custom-built portal gives clients real-time visibility, streamlined job tracking, and fast access to quotes, reports, and compliance updates—all in one place. Automation powers our scheduling and communications, reducing delays and boosting accuracy across every service. With seamless integration into existing systems and a focus on continual innovation, we’ve created a platform that’s as efficient as it is easy to use. Whether you're managing a single property or a large portfolio, our technology works quietly in the background—so you don’t have to.</p>

				<p className={`xl1 forma medium ${styles.tech_subheading_bottom}`}>Ask our team today how our state of the art technology can assist your needs.</p>

				<div className={styles.tech_img}>
					<img src={technology}/>
				</div>

				{/* <button className={styles.tech_cta_button}> */}
				{/* 	<p className={`m2 inter medium`}>More Insights</p> */}
				{/* 	<i className="fa-solid fa-magnifying-glass-plus m3"></i> */}
				{/* </button> */}
			</div>

			<div className={styles.transition_container} style={{ bottom: '-80px' }}>
				<div className={styles.transition_effect_1} style={{ bottom: '50px', borderBottomLeftRadius: '30px', borderBottomRightRadius: '30px', background: "#282828" }}/>
				<div className={styles.transition_effect_2} style={{ bottom: '20px', borderBottomLeftRadius: '30px', borderBottomRightRadius: '30px', background: "#282828" }}/>
				<div className={styles.transition_effect_3} style={{ bottom: '-10px', borderBottomLeftRadius: '30px', borderBottomRightRadius: '30px', background: "#282828" }}/>
			</div>
		</div>
	)
}

const Team = () => {
	return (
		<div className={styles.team_container}>
			<div className={styles.team_content_container}>
				<div className={styles.team_content}>
					<p className={`xxxxl3 forma bold ${styles.cmessage_banner}`}>The MYLO Team</p>
					<p className={`m2 inter light`}>At MYLO, our strength lies in the people behind the service. We’re a dedicated team of multi-qualified professionals who bring genuine care, skill, and pride to everything we do. From trades to technology, our culture is built on collaboration, accountability, and a shared commitment to delivering high-quality outcomes to our clientele.<br/><br/>What sets us apart isn’t just expertise, but the way we work together. MYLO fosters a work environment where team members feel supported, empowered, and inspired to make a difference. We value clear communication, consistency, and a thoughtful approach to every task—whether it’s a small repair or a large-scale compliance project. It’s this genuine care for clients, and for each other, that defines the MYLO experience.</p>

					<div className={`${styles.team_img_outer} ${styles.optimised}`}/>

					{/* <button className={styles.team_cta_button}> */}
					{/* 	<p className={`m2 inter medium`}>Learn More</p> */}
					{/* 	<i className="fa-solid fa-users m3"></i> */}
					{/* </button> */}
				</div>

				<div className={`${styles.team_img_outer} ${styles.non_optimised}`}/>
			</div>
		</div>
	)
}


const Home = () => {
	usePageMetadata({
		title: "MYLO | Home",
		description: "Your all-in-one gateway to everything MYLO. Discover our full suite of services—from maintenance and safety to trades and home modifications—all explained in one easy-to-navigate hub."
	});

  	const containerRef = useRef(null);

  	useEffect(() => {
    	const container = containerRef.current;
    	if (!container) return;

    	const children = Array.from(container.children);
    	const observer = new IntersectionObserver((entries, obs) => {
      		entries.forEach(entry => {
        		if (entry.isIntersecting) {
          			entry.target.classList.add(styles.isVisible);
          			obs.unobserve(entry.target);
        		}
      		});
    	}, { threshold: 0.1 });

    	children.forEach(el => {
      		el.classList.add(styles.fadeInSection);
      		observer.observe(el);
    	});

    	return () => observer.disconnect();
  }, []);


	return (
		<div className={styles.background} ref={containerRef}>
			<Topbar active={"Home"}/>
			<Banner/>
			<HouseBanner/>
			<CompanyMessage/>
			<BannerImage/>
			<Services/>
			<BannerImageTwo/>
			<Technology/>
			<Team/>
			<Footer/>
		</div>
	)
};

export default Home;